export enum NgsUserModuleOutlets {
	ngs_user_profile_view = "ngs-user-profile-view"
}
